/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTreatmentDeliveryPlans } from 'app/entities/treatment-delivery-plan/treatment-delivery-plan.reducer';
import { createEntity, getEntity, reset, updateEntity } from './treatment-contouring.reducer';

export const TreatmentContouringUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const treatmentDeliveryPlans = useAppSelector(state => state.treatmentDeliveryPlan.entities);
  const treatmentContouringEntity = useAppSelector(state => state.treatmentContouring.entity);
  const loading = useAppSelector(state => state.treatmentContouring.loading);
  const updating = useAppSelector(state => state.treatmentContouring.updating);
  const updateSuccess = useAppSelector(state => state.treatmentContouring.updateSuccess);

  const handleClose = () => {
    navigate(`/treatment-contouring${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTreatmentDeliveryPlans({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.contouringDate !== undefined && typeof values.contouringDate !== 'number') {
      values.contouringDate = Number(values.contouringDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...treatmentContouringEntity,
      ...values,
      plan: treatmentDeliveryPlans.find(it => it.id.toString() === values.plan?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...treatmentContouringEntity,
          plan: treatmentContouringEntity?.plan?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.treatmentContouring.home.createOrEditLabel" data-cy="TreatmentContouringCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.treatmentContouring.home.createOrEditLabel">
              Create or edit a TreatmentContouring
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="treatment-contouring-id"
                  label={translate('tinyMedicRestApp.treatmentContouring.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentContouring.structureName')}
                id="treatment-contouring-structureName"
                name="structureName"
                data-cy="structureName"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentContouring.contourData')}
                id="treatment-contouring-contourData"
                name="contourData"
                data-cy="contourData"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentContouring.contouringDate')}
                id="treatment-contouring-contouringDate"
                name="contouringDate"
                data-cy="contouringDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentContouring.active')}
                id="treatment-contouring-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentContouring.cursor')}
                id="treatment-contouring-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentContouring.lastUpdated')}
                id="treatment-contouring-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentContouring.microSec')}
                id="treatment-contouring-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentContouring.timestampEntry')}
                id="treatment-contouring-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="treatment-contouring-plan"
                name="plan"
                data-cy="plan"
                label={translate('tinyMedicRestApp.treatmentContouring.plan')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentDeliveryPlans
                  ? treatmentDeliveryPlans.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/treatment-contouring" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TreatmentContouringUpdate;
